import { useState } from 'react';
import { isEmployeeRole } from '../utils/companyRoles';
import VisitorFormConfiguration from './VisitorFormConfiguration';
import EmployeeFormConfiguration from './EmployeeFormConfiguration';

const Configuration = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = user.role?.toLowerCase();
  const isSuperadmin = role === 'superadmin';
  const isAdmin = role === 'admin' || isSuperadmin;
  const canViewVisitor = isAdmin || isEmployeeRole(role);
  const canViewEmployee = isAdmin;
  const [activeTab, setActiveTab] = useState('visitor');

  if (!canViewVisitor && !canViewEmployee) {
    return <VisitorFormConfiguration />;
  }

  const tabs = [
    ...(canViewVisitor ? [{ id: 'visitor', label: 'Visitor Form' }] : []),
    ...(canViewEmployee ? [{ id: 'employee', label: 'Employee Form' }] : []),
  ];

  const resolvedTab = tabs.some((tab) => tab.id === activeTab) ? activeTab : tabs[0]?.id;

  return (
    <div className="space-y-4">
      {tabs.length > 1 && (
        <div className="wm-page px-0 pb-0">
          <div className="inline-flex rounded-xl border border-slate-200 bg-white p-1 dark:border-white/10 dark:bg-vms-navy">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
                  resolvedTab === tab.id
                    ? 'bg-[#0070b1] text-white shadow-sm'
                    : 'text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {resolvedTab === 'employee' ? <EmployeeFormConfiguration /> : <VisitorFormConfiguration />}
    </div>
  );
};

export default Configuration;
